import React, { useRef } from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Flightbooking from './Flightbooking';
import HotelReservation from './HotelReservation';
import InquiryForm from './InquiryForm';
import HeroRotator from '../components/HeroRotator';
import FlightSearchForm from '../components/booking/FlightSearchForm';
import axios from 'axios';
import './home-about.css';
import './services.css';
import './destinations.css';
import './packages.css';
import './lets-travel.css';

export default function Home() {


  
  const fetchCountries = async () => {

    try {
      const response = await axios.post(
        "https://b2b.withinearth.com/api/xconnect/Countries/",
        {
          Token: ''
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

     console.log(response.data)
    } catch (err) {
      
    } finally {
    }
  };

  
const [Searchvalue, setSearchvalue] = useState('')
const contactRef = useRef(null);

  

  

  

  const handlechange  = (value) =>{
setSearchvalue(value);
  }

  const scrollToContact = () => {
  // contactRef.current?.scrollIntoView({
  //   behavior: "smooth",
  //   block: "start"
  // });
  // setIsOpen(true);
  setInquiryFormOpen(true)
};
  const [isOpen, setIsOpen] = useState(false);
  const [isHotelReservationOpen, setIsHotelReservationOpen] = useState(false);
  const [InquiryFormOpen, setInquiryFormOpen] = useState(false);
  const [isIframeOpen, setIsIframeOpen] = useState(false);
  const googleFlightsUrl = "https://www.google.com/travel";

  return (
    <div>

      <Flightbooking isOpen={isOpen} setIsOpen={setIsOpen} />
      <HotelReservation isOpen={isHotelReservationOpen} setIsOpen={setIsHotelReservationOpen} />
      <InquiryForm isOpen={InquiryFormOpen} setIsOpen={setInquiryFormOpen} />
      <div className="container-fluid bg-primary py-5 mb-5 hero-header home-hero">
        <HeroRotator
          images={[
            'assets/img/cover_image/image_1.jpg',
            'assets/img/cover_image/image_2.jpg',
            'assets/img/cover_image/image_3.jpg',
            'assets/img/cover_image/image_4.jpg',
          ]}
          interval={2000}
        />
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center hero-content">
          
              <h1 className="display-3 text-white mb-3 animated slideInDown">
                Falcon Destinations Your Online Travel Agent
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                Travel Smarter. Explore Further. Book with confidence. Travel with ease. Explore without limits.
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap hero-buttons mb-4 animated slideInDown">
                <Link to="/bookingflight" type="button" className="btn btn-light btn-lg hero-btn" >
                  Book Now
                </Link>
                <Link to="/packages" className="btn btn-outline-light btn-lg hero-btn">
                  View Packages
                </Link>
                <Link to="/VisaVaccination" className="btn btn-outline-light btn-lg hero-btn">
                  Vaccination Certificate
                </Link>
              </div>
              <div className="hero-badges d-flex flex-wrap justify-content-center gap-3 text-white small animated slideInDown">
                <span className="hero-badge"><i className="fa fa-certificate" /> IATA Approved</span>
                <span className="hero-badge"><i className="fa fa-globe" /> Worldwide Service</span>
                <span className="hero-badge"><i className="fa fa-briefcase" /> Corporate Travel</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container home-flight-search-wrap">
        <FlightSearchForm />
      </div>

      {isIframeOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ width: 'min(960px, 100%)', maxWidth: '100%', padding: 0, overflow: 'hidden' }}>
            <div className="modal-header" style={{ borderBottom: '1px solid #e5e7eb', padding: '16px 22px', background: '#fff' }}>
              <div className="modal-title" style={{ alignItems: 'center' }}>
                <div className="modal-title-icon" aria-hidden="true" style={{ background: '#0b2ea9' }}>
                  <i className="fa fa-plane" style={{ color: '#fff' }} />
                </div>
                <div className="modal-title-text">
                  <h2 style={{ margin: 0, fontSize: '20px' }}>Google Flights</h2>
                  <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#667085' }}>Search and compare flights inside a modal.</p>
                </div>
              </div>
              <button type="button" className="close-x" aria-label="Close" onClick={() => setIsIframeOpen(false)}>
                &times;
              </button>
            </div>
            <div style={{ width: '100%', height: '80vh', minHeight: '560px' }}>
              {/* <iframe
                src={googleFlightsUrl}
                title="Google Flights"
                width="100%"
                height="100%"
                style={{ border: '0', minHeight: '560px' }}
                allowFullScreen
              /> */}
            </div>
          </div>
        </div>
      )}

    <section className="home-about-redesign py-5">
      <div className="container">
        <div className="home-about-shell">
          <div className="home-about-left wow fadeInUp" data-wow-delay="0.1s">
            <img src="assets/img/aboutus1.jpg" alt="Falcon Destinations office and travel services" />
            <div className="home-about-pill-row">
              <span><i className="fa fa-certificate" /> IATA Agent</span>
              <span><i className="fa fa-building" /> Al-Rahim Group</span>
              <span><i className="fa fa-globe" /> Worldwide Service</span>
            </div>
          </div>

          <div className="home-about-right wow fadeInUp" data-wow-delay="0.2s">
            <h6 className="section-title bg-white text-start text-primary pe-3">About Us</h6>
            <h2>
               <span> Discover Falcon Destinations</span>
            </h2>
            <p>
              Falcon Destinations (Pvt.) Ltd as IATA agent in Karachi-Pakistan. The agency is a part of high profiled group Al-Rahim Group of Companies in Pakistan. Falcon Destinations (Pvt.) Limited is graded as Global Destinations and Travel Management Company in Pakistan.
            </p>
            <p>
              Falcon Destinations (Pvt.) Limited is licensed from Department of Tourist Services, Govt. of Pakistan and IATA approved agent for travel related services, holiday packages and Destination Management Services. We are proud Members of the Travel Agent&apos;s Association of Pakistan (TAAP) and Karachi Chamber of Commerce (KCCI).
            </p>

            <div className="home-about-points">
              <div><i className="fa fa-check-circle" /> Dedicated travel team since inception</div>
              <div><i className="fa fa-check-circle" /> Trusted by corporates and organizations</div>
              <div><i className="fa fa-check-circle" /> Quality services with timely responses</div>
              <div><i className="fa fa-check-circle" /> Competitive rates and reliable support</div>
            </div>

            <Link to="/about" className="home-about-btn">
              Explore Full About <i className="fa fa-arrow-right" />
            </Link>
          </div>
        </div>
      </div>
    </section>
    {/* About End */}
    {/* Service Start */}
    <div className="container-xxl services-section">
      <div className="container">
        <div className="text-center services-heading wow fadeInUp" data-wow-delay="0.1s">
          {/* <h6 className="section-title">Services</h6> */}
          <h1>Our Services</h1>
        </div>
        <div className="row g-4 services-grid">
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-card-top">
                  <div className="service-icon">
                    <i className="fa fa-plane" />
                  </div>
                </div>
                <h5 className="service-title">Book a Flight</h5>
                <p className="service-text">
                  Search, compare, and reserve airline tickets online for your travel dates.
                </p>
                <Link to="/bookingflight" className="service-action">
                  Book Now
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-card-top">
                  <div className="service-icon">
                    <i className="fa fa-hotel" />
                  </div>
                </div>
                <h5 className="service-title">Hotel Reservation</h5>
                <p className="service-text">
                  Reserve rooms at hotels, resorts, or guesthouses and secure your stay instantly.
                </p>
                <button type="button" className="service-action" onClick={() => setIsHotelReservationOpen(true)}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-card-top">
                  <div className="service-icon">
                    <i className="fa fa-user" />
                  </div>
                </div>
                <h5 className="service-title">Travel Guides</h5>
                <p className="service-text">
                  Expert tips and itineraries to help plan and explore destinations efficiently.
                </p>
                <button type="button" className="service-action" onClick={scrollToContact}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-card">
              <div className="service-card-inner">
                <div className="service-card-top">
                  <div className="service-icon">
                    <i className="fa fa-car" />
                  </div>
                </div>
                <h5 className="service-title">Car Rental</h5>
                <p className="service-text">
                  Reserve a vehicle online for convenient travel at your destination.
                </p>
                <button type="button" className="service-action" onClick={scrollToContact}>
                  Book Now
                </button>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-globe text-primary mb-4" />
                <h5>WorldWide Tours</h5>
                <p>
                  Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita
                  amet diam
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-hotel text-primary mb-4" />
                <h5>Hotel Reservation</h5>
                <p>
                  Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita
                  amet diam
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-user text-primary mb-4" />
                <h5>Travel Guides</h5>
                <p>
                  Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita
                  amet diam
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="service-item rounded pt-3">
              <div className="p-4">
                <i className="fa fa-3x fa-cog text-primary mb-4" />
                <h5>Event Management</h5>
                <p>
                  Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita
                  amet diam
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
    {/* Service End */}
    {/* Destination Start */}
    <div className="container-xxl destinations-section">
      <div className="container">
        <div className="text-center destinations-heading wow fadeInUp" data-wow-delay="0.1s">
          {/* <h6 className="section-title">Destination</h6> */}
          <h1>Popular Destinations</h1>
        </div>
        <div className="destinations-grid">
          <div className="destinations-main">
            <div className="destination-card wow zoomIn" data-wow-delay="0.1s">
              <img src="assets/img/dubai.jpg" alt="Dubai destination" className="destination-image" />
              <div className="destination-discount">30% OFF</div>
              <div className="destination-overlay">
                <div className="destination-name">Dubai</div>
              </div>
            </div>
            <div className="destination-card wow zoomIn" data-wow-delay="0.3s">
              <img src="assets/img/Malaysia.jpg" alt="Malaysia destination" className="destination-image" />
              <div className="destination-discount">25% OFF</div>
              <div className="destination-overlay">
                <div className="destination-name">Malaysia</div>
              </div>
            </div>
            <div className="destination-card wow zoomIn" data-wow-delay="0.5s">
              <img src="assets/img/nepal.jpg" alt="Nepal destination" className="destination-image" />
              <div className="destination-discount">35% OFF</div>
              <div className="destination-overlay">
                <div className="destination-name">Nepal</div>
              </div>
            </div>
          </div>
          <div className="destination-card destination-featured wow zoomIn" data-wow-delay="0.7s">
            <img src="assets/img/indonasia.jpg" alt="Indonesia destination" className="destination-image" />
            <div className="destination-discount">20% OFF</div>
            <div className="destination-overlay">
              <div className="destination-name">Indonesia</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Destination Start */}
    {/* Package Start */}
    <section className="packages-section py-5">
      <div className="container">
        <div className="text-center wow fadeInUp packages-heading" data-wow-delay="0.1s">
          {/* <h6 className="section-title bg-white text-center text-primary px-3">
            Packages
          </h6> */}
          <h1 className="mb-5">Awesome Packages</h1>
          <p className="packages-subtitle mx-auto">
            Exclusive holiday packages with premium details, curated pricing, and memorable travel experiences designed for modern explorers.
          </p>
        </div>
           <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Umrah.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Umrah – Ramzan
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />19  days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Umrah</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Umrah – Ramzan 1st Departure Group
                </p>
                <div className="d-flex justify-content-center mb-2">
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/hajjpackage.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  hajj
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />12 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">hajj</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Hajj Package offers a smooth, stress-free journey from start to finish.
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Iraq.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Ziyarat
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />12 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Ziyarat</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
          Explore the rich history and sacred landmarks of Islam with our Group Ziarat packages.
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/dubai.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Dubai
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Dubai</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Burj Khalifa | Dubai Mall & Fountain Show | Palm Jumeirah |  Desert Safari | Al Fahidi (Old Dubai) & Dubai Creek
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Sri Lanka.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Sri Lanka
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Sri Lanka</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Sigiriya Rock Fortress | Kandy & Temple of the Tooth | Ella (Nine Arches Bridge) | Yala National Park | Galle Fort
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Malaysia.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Malaysia
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Malaysia</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
          Kuala Lumpur (Petronas Twin Towers) | Langkawi | Penang (George Town) | Genting Highlands | Cameron Highlands
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Egypt.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Egypt
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Egypt</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                 Pyramids of Giza | The Sphinx | Luxor (Valley of the Kings & Karnak Temple) | Nile River Cruise | Red Sea (Sharm El Sheikh / Hurghada)
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Singapore.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Singapore
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Singapore</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                 Marina Bay Sands & SkyPark | Gardens by the Bay | Sentosa Island | Merlion Park | Chinatown & Little India
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Turkey.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Turkey
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Turkey</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                 Istanbul (Hagia Sophia & Blue Mosque) | Cappadocia (Hot Air Balloons) | Pamukkale | Ephesus | Antalya
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Honeymoon.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Bali
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />2 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Honeymoon</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Maldives | Bali | Santorini | Paris | Mauritius
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/Nepalpa.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Nepal
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />7 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Nepal</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                Kathmandu | Pokhara | Chitwan National Park | Nagarkot | Lumbini
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="package-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/thailand.jpg" alt="" />
              </div>
              <div className="d-flex border-bottom">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  Thailand
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />8 days
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />1 Person
                </small>
              </div>
              <div className="text-center p-4">
                <h3 className="mb-0">Thailand</h3>
                <div className="mb-3">
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                  <small className="fa fa-star text-primary" />
                </div>
                <p>
                 Bangkok | Phuket | Krabi | Chiang Mai | Pattaya
                </p>
                <div className="d-flex justify-content-center mb-2">
                {/* <a
                    href="#"
                    className="btn btn-sm btn-primary px-3 border-end"
                    style={{ borderRadius: "30px 0 0 30px" }}
                  >
                    Read More
                  </a> */}
                  <a
                    className="btn btn-sm btn-primary px-3"
                    style={{ borderRadius: "0 30px 30px 0" }}
                     onClick={scrollToContact}
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* Package End */}
    {/* Booking Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s" ref={contactRef}
  id="contactus">
      <div className="container">
        <div className="booking p-5">
          <div className="row g-5 align-items-center">
            <div className="col-md-6 text-white">
              <h6 className="text-white text-uppercase">Booking</h6>
              <h1 className="text-white mb-4">Online Booking</h1>
              <p className="mb-4">
               Plan your entire trip anytime, anywhere, from your device. Compare prices and packages to get the most value for your travel.
              </p>
              <p className="mb-4">
               Easily reserve flights, hotels, and tours with Falcon Destination through a simple, secure online platform.
              </p>
              <a className="btn btn-outline-light py-3 px-5 mt-2">
                Read More
              </a>
            </div>
            <div className="col-md-6">
              <h1 className="text-white mb-4">Book A Tour</h1>
              <form>
                <div className="row g-3">
      
                  <div className="col-12">
                    <button
                      className="btn btn-outline-light w-100 py-3"
                      type="submit"
                       onClick={scrollToContact}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* Booking Start */}
    {/* Process Start */}
    {/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Process
          </h6>
          <h1 className="mb-5">3 Easy Steps</h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-globe fa-3x text-white" />
              </div>
              <h5 className="mt-4">Choose A Destination</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
                Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                diam eos erat ipsum et lorem et sit sed stet lorem sit
              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-dollar-sign fa-3x text-white" />
              </div>
              <h5 className="mt-4">Pay Online</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
                Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                diam eos erat ipsum et lorem et sit sed stet lorem sit
              </p>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-plane fa-3x text-white" />
              </div>
              <h5 className="mt-4">Fly Today</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <p className="mb-0">
                Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
                diam eos erat ipsum et lorem et sit sed stet lorem sit
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* Process Start */}
    {/* Team Start */}
    {/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Travel Guide
          </h6>
          <h1 className="mb-5">Meet Our Guide</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-1.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-2.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-3.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item">
              <div className="overflow-hidden">
                <img className="img-fluid" src="assets/img/team-4.jpg" alt="" />
              </div>
              <div
                className="position-relative d-flex justify-content-center"
                style={{ marginTop: "-19px" }}
              >
                <a className="btn btn-square mx-1">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-square mx-1">
                  <i className="fab fa-instagram" />
                </a>
              </div>
              <div className="text-center p-4">
                <h5 className="mb-0">Full Name</h5>
                <small>Designation</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* Team End */}
    {/* Testimonial Start */}
    {/* <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Testimonial
          </h6>
          <h1 className="mb-5">Our Clients Say!!!</h1>
        </div>
        <div className="owl-carousel testimonial-carousel position-relative">
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-1.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-2.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-3.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div className="testimonial-item bg-white text-center border p-4">
            <img
              className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
              src="assets/img/testimonial-4.jpg"
              style={{ width: 80, height: 80 }}
            />
            <h5 className="mb-0">John Doe</h5>
            <p>New York, USA</p>
            <p className="mt-2 mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
        </div>
      </div>
    </div> */}
    {/* Testimonial End */}
    {/* Let's Travel Together Start */}
    <section className="lets-travel-section py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="lets-travel-title mb-4">LET'S TRAVEL TOGETHER</h2>
            <p className="lets-travel-subtitle mb-4">
              Partner with Falcon Destinations for all your travel management needs
            </p>
            <div className="lets-travel-info mb-4">
              <div className="lets-travel-location mb-3">
                <i className="fa fa-map-marker-alt me-2"></i>
                Karachi, Pakistan
              </div>
              <div className="lets-travel-approval mb-4">
                <i className="fa fa-globe me-2"></i>
                IATA Approved — Al-Rahim Group of Companies
              </div>
            </div>
            <p className="lets-travel-description mb-4">
              We look forward to serving high-profile organisations, corporates, pharmaceutical companies, and all travellers with assurance and commitment.
            </p>
            <p className="lets-travel-commitment">
              Our team is dedicated to being your preferred Destination Ground Arrangement & Travel Management partner.
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* Let's Travel Together End */}
    </div>
  )
}
